<!-- <div *ngIf="loading"
     class="row mt-4">
  <div class="col-12">
    <div class="alert alert-info text-center"
         role="alert">
      <i class="fa fa-spin fa-refresh fa-2x"></i>
      <h4 class="alert-heading">Cargando datos...</h4>
    </div>
  </div>
</div> -->



<div class="row animated fadeIn fast">

  <div class="col-12">
    <div class="card border rounded animated fadeIn fast">

      <div class="card-body">


        <!-- cabecera -->
        <div class="row mb-2">

          <div class="col-6">
            <div class="form-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     (keyup)="buscarTodo($event)" />
            </div>
          </div>

          <div class="col-6">
            <form>

              <div class="row float-right">

                <div class="col-sm-6">
                  <button type="button"
                          (click)="openIntranetCliente()"
                          class="btn btn-outline-info "
                          data-toggle="tooltip">
                    <i class="fa-solid fa-laptop"></i>
                    Intranet del Cliente
                  </button>
                </div>

                <div class="col-sm-3">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group float-right">
                    <div class="btn-group">

                      <a type="button"
                         [routerLink]="'/panel/cliente_edit/new'"
                         class="btn btn-outline-info btn-circle"
                         title="Nuevo">
                        <i class="fa-solid fa-plus"></i>
                      </a>

                      <button type="button"
                              (click)="getListaCli()"
                              class="btn btn-outline-info btn-circle"
                              title="Recargar datos">
                        <i class="fa-solid fa-sync"></i>
                      </button>

                      <button type="button"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>

                    </div>
                  </div>
                </div>

              </div>

            </form>
          </div>

        </div>


        <!-- ngx-datatable -->
        <div class="rounded border">

          <!-- datatable -->
          <ngx-datatable class='bootstrap'
                         [style.width]="'100%'"
                         [columns]="columns"
                         [columnMode]="'force'"
                         [columnMode]="ColumnMode.force"
                         [loadingIndicator]="loading"
                         [headerHeight]="70"
                         [footerHeight]="50"
                         [rowHeight]="50"
                         [limit]="rowsLimit"
                         [rows]='rows'
                         [messages]="messages"
                         [rowClass]="getRowClass">


            <!-- id -->
            <ngx-datatable-column name="id"
                                  [width]="60"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header noSearch"
                     (click)="sort()">
                  <h6 class="title link">ID</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- foto -->
            <ngx-datatable-column name="foto"
                                  [width]="50"
                                  [sortable]="false"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-column="column">
                <div class="header noSearch">
                  <h6 class="title">Imágen</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div>
                  <img [src]="fotoDir +'/clientes/' + value"
                       loading="lazy"
                       height="25px"
                       alt="Foto"
                       title="Foto">
                </div>
              </ng-template>
            </ngx-datatable-column>


            <!-- nombre -->
            <ngx-datatable-column name="nombre"
                                  [flexGrow]="3"
                                  [minWidth]="200">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'nombre')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Nombre</h6>
                </div>
              </ng-template>

              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>

                <span *ngIf="row.url"
                      style="display: inline-block;">
                  <a href="{{row.url}}"
                     target="_blank"
                     title="Abrir {{row.url}}">
                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                  </a>
                </span>

                <span *ngIf="!row.url"
                      style="display: inline-block;">
                  <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)">
                  </div>
                </span>

              </ng-template>

            </ngx-datatable-column>


            <!-- acceso intranet -->
            <ngx-datatable-column name="intranet"
                                  [width]="70"
                                  [sortable]="false"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-column="column">
                <div class="header noSearch text-center">
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div class="text-center">
                  <span *ngIf="row.acceso_intranet === 'S'"
                        class="text-secondary"
                        title="Con acceso a la intranet de Clientes">
                    <i class="fa-solid fa-laptop"></i>
                  </span>
                </div>
              </ng-template>
            </ngx-datatable-column>



            <!-- email -->
            <ngx-datatable-column name="email"
                                  [flexGrow]="2"
                                  [minWidth]="180">

              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'email')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Email</h6>
                </div>
              </ng-template>

              <ng-template ngx-datatable-cell-template
                           let-rowIndex="rowIndex"
                           let-value="value"
                           let-row="row">
                <span title="Doble click para editar"
                      class="editable loadVal"
                      (dblclick)="editing[rowIndex + '-email'] = true"
                      *ngIf="!editing[rowIndex + '-email']">
                  <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                </span>

                <div class="form-group">
                  <input autofocus
                         (blur)="updateValue($event, 'email', rowIndex)"
                         *ngIf="editing[rowIndex + '-email']"
                         type="text"
                         [value]="value"
                         class="form-control-sm editando" />
                </div>

              </ng-template>
            </ngx-datatable-column>



            <!-- telefono -->
            <ngx-datatable-column name="telefono"
                                  [width]="120">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'telefono')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Teléfono</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- almacen_desde -->
            <ngx-datatable-column name="Reserva espacio desde"
                                  prop='almacen_desde'
                                  [width]="140">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'almacen_desde')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link"
                      title="Espacio reservado en almacén desde ubicación">Espacio Desde</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template
                           class="mt-30">
                <div class="monospace"
                     title="{{funcLib.CodUbiDecript(value)}}"
                     [innerHTML]="funcLib.resaltarTexto(funcLib.formatUbicacion(value), textoDestacado | mask: '00.00.00.00.00.00')"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- almacen_hasta -->
            <ngx-datatable-column name="Reserva espacio hasta"
                                  prop='almacen_hasta'
                                  [width]="140">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'almacen_hasta')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link"
                      title="Espacio reservado en almacén hasta ubicación">Espacio Hasta</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div class="monospace"
                     title="{{funcLib.CodUbiDecript(value)}}"
                     [innerHTML]="funcLib.resaltarTexto(funcLib.formatUbicacion(value), textoDestacado | mask: '00.00.00.00.00.00')"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- Acciones -->
            <ngx-datatable-column [width]="10"
                                  [sortable]="false">

              <ng-template let-row="row"
                           let-value="value"
                           ngx-datatable-cell-template>

                <div ngbDropdown
                     class="d-inline-block "
                     container="body">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          style="border-width: 1px;">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-left">


                    <a [routerLink]="['/panel/cliente_edit',row.id]"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="EDITAR cliente">
                      <i class="fa-solid fa-user-pen"></i> Editar cliente
                    </a>

                    <a [routerLink]="['/panel/cliente_edit_intranet',row.id]"
                       class="link mr-2 pointer dropdown-item"
                       placement="top"
                       title="Configurador de INTRANET del cliente">
                      <i class="fa-solid fa-laptop"></i> Configurar INTRANET
                    </a>

                    <a [routerLink]="['/panel/cliente_edit_fac',row.id]"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="Configurador de FACTURACIÓN">
                      <i class="fa-solid fa-file-invoice"></i> Configurar FACTURACIÓN
                    </a>

                    <a (click)="row.acceso_intranet === 'S' ? modalAvisoCli(row) : null"
                       [ngClass]="{'disabled': row.acceso_intranet !== 'S'}"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="Enviar una NOTIFICACIÓN que verá en la intranet del cliente">
                      <i class="fa-solid fa-envelope"></i> NOTIFICACIÓN vía Intranet
                    </a>

                    <a href="javascript: void(0);"
                       (click)='deleteReservasCliente(row)'
                       class="link mr-2 dropdown-item"
                       title="Eliminar reservas de STOCK activas">
                      <i class="fa-solid fa-xmark"></i> Eliminar reservas
                    </a>

                  </div>
                </div>

              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>

        </div>


      </div>
    </div>
  </div>

</div>